import { ContentArticle } from '../types';
import { Changelog } from './changelog';

export const pages: { [key: string]: ContentArticle } = {
  changelog: Changelog,
};
